import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import { stringToDominicanPhoneNumber } from "../../../../../utilities/functions/FormatterUtil";

function DetailCompany({ selectedCompany }) {
  if (!selectedCompany) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        background: '#EEF2FF',
        border: '1px solid #D0DBF3',
        borderRadius: '20px',
        p: 3,
        mb: 3,
        gap: 2.5,
        boxShadow: 'none'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '64px',
          height: '64px',
          borderRadius: '16px',
          backgroundColor: '#0F2350',
          color: '#FFFFFF',
          boxShadow: '0 4px 12px rgba(15, 35, 80, 0.2)',
          flexShrink: 0
        }}
      >
        <ApartmentIcon sx={{ fontSize: '36px' }} />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontWeight: 700,
            color: '#0B8296',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontSize: '11.5px',
            fontFamily: 'Roboto, sans-serif',
            mb: 0.5
          }}
        >
          Empresa Seleccionada
        </Typography>

        <Typography
          sx={{
            fontWeight: 800,
            color: '#0F2350',
            fontFamily: 'Merriweather, Georgia, serif',
            fontSize: { xs: '20px', sm: '24px' },
            mb: 1.5,
            lineHeight: 1.3
          }}
        >
          {selectedCompany.company_name ?? selectedCompany.name ?? ""}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2.5, flexWrap: 'wrap', alignItems: 'center' }}>
          <Chip
            icon={<BadgeIcon sx={{ fontSize: '16px !important', color: '#0F2350 !important' }} />}
            label={`RNC: ${selectedCompany.company_rnc ?? selectedCompany.rnc ?? "-"}`}
            sx={{
              bgcolor: '#FFFFFF',
              border: '1px solid #CFDCE0',
              fontWeight: 700,
              fontFamily: 'Roboto, sans-serif',
              fontSize: '13px',
              color: '#0F2350',
              py: 0.5,
              px: 0.5
            }}
          />

          <Chip
            icon={<PhoneIcon sx={{ fontSize: '16px !important', color: '#0B8296 !important' }} />}
            label={stringToDominicanPhoneNumber(selectedCompany.company_phone || selectedCompany.phone) || "-"}
            sx={{
              bgcolor: '#FFFFFF',
              border: '1px solid #CFDCE0',
              fontWeight: 700,
              fontFamily: 'Roboto, sans-serif',
              fontSize: '13px',
              color: '#0F2350',
              py: 0.5,
              px: 0.5
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default DetailCompany;
